import React from 'react';
import './Thumbnail.css';  // Import the CSS file

const Thumbnail = ({ displayThumbnail }) => {
  return (
    displayThumbnail ? (
      <img 
        src={displayThumbnail} 
        alt="Thumbnail" 
        className="thumbnail-image"  // Add the class name here
      />
    ) : null
  );
};

export default Thumbnail;
